module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_hiroshima-d884227bd8d65c5aecbdc9d63b2ada55.png";